import api from "@helpers/api";

import { URLS } from "@constants/urls";
import { STATUS } from "@constants/status.hrm";

import { calculateDaysDifference } from "@utils/duration";
import { LeaveApplyType } from "@type/HRM/leave-apply";

const { LEAVE, EMPLOYEES, SEND_FOR_APPROVAL } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPointBaseURL = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${LEAVE}`;

export const applyLeave = (() => {
  return async (
    formData: LeaveApplyType,
    employeeMasterId: string,
    afterEffect: (param: any) => void,
  ): Promise<{ data: LeaveApplyType }> => {
    return api
      .post(`${apiEndPointBaseURL}/${EMPLOYEES}/${employeeMasterId}`, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const updateLeave = (() => {
  return async (
    formData: LeaveApplyType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: LeaveApplyType }> => {
    const {
      id,
      employeeMasterId,
      leaveTypeId,
      leaveNatureId,
      startDate,
      endDate,
      applicationDate,
      joiningDate,
      contactAddressOnLeave,
      leaveReason,
      delegatedEmployeeId,
      leaveDocuments,
    } = formData;

    return api
      .put(`${apiEndPointBaseURL}/${id}/${EMPLOYEES}/${employeeMasterId}`, {
        leaveTypeId,
        leaveNatureId,
        startDate,
        endDate,
        applicationDate,
        joiningDate,
        leaveDaysCount: calculateDaysDifference(startDate, endDate),
        contactAddressOnLeave,
        leaveReason,
        delegatedEmployeeId,
        leaveDocuments,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const sendLeaveForApproval = (() => {
  return async (
    formData: LeaveApplyType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: LeaveApplyType }> => {
    return api
      .post(`${apiEndPointBaseURL}/${SEND_FOR_APPROVAL}`, {
        ...formData,
      })
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const leaveApprovalAction = (() => {
  return async (
    formData: LeaveApplyType,
    afterEffect: (param: any) => void,
  ): Promise<{ data: LeaveApplyType }> => {
    return api
      .put(
        `${apiEndPointBaseURL}/${SEND_FOR_APPROVAL}/${formData.leaveDetailsId}`,
        {
          ...formData,
        },
      )
      .then((response) => {
        afterEffect({
          data: response,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const getDraftLeave = (() => {
  return async (
    employeeMasterId: string,
    leaveId: string | number | undefined,
  ): Promise<{ data: any }> => {
    return api
      .get(`${apiEndPointBaseURL}/${leaveId}/${EMPLOYEES}/${employeeMasterId}`)
      .then((response) => {
        return response.data;
      });
  };
})();
